<script>
    import ctrlShowText from "@/components/ctrl-show-text/ctrl-show-text.vue";
    import GoodsLabel from "@/components/goods-label/goods-label.vue";
    import goodsCodeLabel from "@/components/goods-label/goods-code-label.vue";
    import goodsGroupLabel from "@/components/goods-label/goods-group-label.vue";
    import goodsImage from "@/components/goods-image/goods-image.vue"
    export default {
        name: "goods-info",
        components: {ctrlShowText,GoodsLabel,goodsCodeLabel,goodsGroupLabel,goodsImage},
        props: {
            item: {
                type: Object,
                default: () => {
                }
            },
            tag: {
                type: String,
                default: ""
            },
            activity:{
                type: String,
                default: ""
            }
        },
        computed:{
            returnArr(){
                let obj = {
                    wesArr:['规格','效期','厂家','公司'],
                    traArr:['规格','生产日期','厂家','公司']
                }
                if(this.activity === "组合套餐"){
                    obj.wesArr = ['规格','数量','效期','厂家','公司']
                    obj.traArr = ['规格','数量','生产日期','厂家','公司']
                }
                return obj;
            },
            goods_size(){
                let str = '';
                if(this.item){
                    let { attr } = this.item;
                    if(attr){
                        str = attr.goods_size || '';
                    }
                }
                return str;
            }
        }
    }
</script>

<template>
    <div class="goods-info-wrap" @click="$router.pushToTab({ path: '/sku-' + (item.sku_id || item.goods_id) })">
        <div class="img-wrap">
            <goodsImage :goods="item" :imageSize="70"></goodsImage>
        </div>
        <div class="info-wrap">
            <p  class="title">
                <goods-label :goods="item" width="500"></goods-label>
                <span :class="item.join_coupon==0&&item.join_manjian==0?'greenText':''">{{ item.sku_name }}</span>
                <span style="color: #ff547b;font-size: 12px;" v-if="goods_size !=''">({{ goods_size }})</span>
            </p>
            <goods-group-label :goods="item"></goods-group-label>
            <ctrlShowText :showLimit="tag==='秒杀'" :info="item" type="custom" size="12px" gap="10px" margin="10px 0"
            :wesArr="returnArr.wesArr" :traArr="returnArr.traArr"></ctrlShowText>
        </div>
    </div>
</template>

<style scoped lang="scss">
.greenText{
    color: #00a000;
}
    .goods-info-wrap {
        display: flex;
        .img-wrap {
            width: 70px;
            height: 70px;
            margin-right: 10px;
            cursor: pointer;
        }

        .info-wrap {
            cursor: pointer;
            flex: 1;
            overflow: hidden;
            .title {
                display: flex;
                align-items: center;
                gap: 6px;
                font-size: 14px;
                line-height: 1;
                padding-bottom: 6px;
            }
            .familiar {
                color: #878585;
                font-size: 12px;
                span {
                    font-size: $ns-font-size-sm;
                    color: #9a9a9a;
                }
            }


        }
    }
</style>
